// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"42120743","123":"a64b0496","384":"f5fa2670","427":"f3b3ce6f","462":"298fc63e","624":"64170070","671":"38204c1f","791":"711eef92","831":"434c451a","958":"2c662e32"}[chunkId] + ".chunk.js";
};